module.exports = __webpack_public_path__ + "img/78.acb9068b.jpg";